/* Kingdom theme — King of Violence */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var cartType = theme.cartType || 'drawer';
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ------------------------------------------------------------------
     Cart drawer
  ------------------------------------------------------------------ */
  var lastFocus = null;
  function getDrawer() { return $('[data-cart-drawer]'); }

  function openCart() {
    var drawer = getDrawer();
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var panel = $('.cart-drawer__panel', drawer);
    if (panel) window.setTimeout(function () { panel.focus(); }, 50);
    return true;
  }

  function closeCart() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(fresh.getAttribute('data-count') || 0);
    }
  }

  function changeLine(line, quantity) {
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('is-busy');
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  function addItems(items) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        if (cartType === 'drawer' && getDrawer() && data.sections) {
          renderDrawer(data.sections['cart-drawer']);
          openCart();
        } else {
          window.location.href = routes.cart_url;
        }
        return data;
      });
    });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-open]');
    if (opener && cartType === 'drawer' && getDrawer()) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }
    var change = event.target.closest('[data-line-change]');
    if (change) {
      event.preventDefault();
      changeLine(change.getAttribute('data-line'), change.getAttribute('data-qty'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var drawer = getDrawer();
    if (drawer && drawer.classList.contains('is-open')) closeCart();
    $$('details[open]').forEach(function (d) {
      if (d.matches('.site-nav__details, .filter, .mobile-nav')) d.removeAttribute('open');
    });
  });

  /* ------------------------------------------------------------------
     Add to cart (product form + quick add + add-ons + bundle choices)
  ------------------------------------------------------------------ */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-product-form], [data-quick-add]')) return;
    event.preventDefault();
    if (form.reportValidity && !form.reportValidity()) return;

    var data = new FormData(form);
    var properties = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    var items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: properties }];

    var section = form.closest('[data-product-section]');
    if (section && form.matches('[data-product-form]')) {
      $$('[data-addon]:checked', section).forEach(function (box) {
        items.push({ id: Number(box.value), quantity: 1 });
      });
    }

    var buttons = section ? $$('[data-add-button]', section) : $$('[type="submit"]', form);
    var error = $('[data-form-error]', section || form);
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

    addItems(items)
      .then(function () {
        if (error) error.hidden = true;
        if (section) $$('[data-addon]:checked', section).forEach(function (box) { box.checked = false; });
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
        else window.alert(err.message);
      })
      .finally(function () {
        buttons.forEach(function (b) {
          b.removeAttribute('aria-busy');
          b.disabled = b.hasAttribute('data-unavailable');
        });
      });
  });

  /* ------------------------------------------------------------------
     Product page: variant picker, gallery, sticky add-to-cart
  ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.hasAttribute('data-initialized')) return;
    section.setAttribute('data-initialized', '');

    var json = $('[data-variants]', section);
    var picker = $('[data-variant-picker]', section);
    var form = $('[data-product-form]', section);
    var gallery = $('[data-gallery]', section);
    if (!json || !form) return;

    var variants = JSON.parse(json.textContent);
    var select = $('select[name="id"]', form);

    function findVariant(chosen) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function chosenOptions() {
      return $$('fieldset', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function setButtons(available, labelText) {
      $$('[data-add-button]', section).forEach(function (b) {
        if (available) b.removeAttribute('data-unavailable'); else b.setAttribute('data-unavailable', '');
        b.disabled = !available;
      });
      $$('[data-add-label]', section).forEach(function (l) {
        l.textContent = labelText || (available ? (l.getAttribute('data-default') || 'Add to cart') : 'Sold out');
      });
    }

    function showMedia(id) {
      if (!gallery || !id) return;
      var media = $('[data-media-id="' + id + '"]', gallery);
      if (!media) return;
      var hero = $('.product__media--hero', gallery);
      if (hero && hero !== media) hero.classList.remove('product__media--hero');
      media.classList.add('product__media--hero');
      gallery.insertBefore(media, gallery.firstElementChild);
      gallery.scrollTo({ left: 0, behavior: 'smooth' });
    }

    function update(fromUser) {
      var chosen = chosenOptions();
      $$('[data-option-value]', picker).forEach(function (el, i) { el.textContent = chosen[i] || ''; });

      $$('fieldset', picker).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = chosen.slice();
          test[idx] = input.value;
          var match = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      var variant = findVariant(chosen);
      if (!variant) { setButtons(false, 'Unavailable'); return; }
      if (select) select.value = String(variant.id);
      setButtons(variant.available);

      var html = '<span class="price' + (variant.compare ? ' price--sale' : '') + '"><span class="price__current">' + variant.price + '</span>' +
        (variant.compare ? '<s class="price__compare">' + variant.compare + '</s>' : '') + '</span>';
      $$('[data-price]', section).forEach(function (p) { p.innerHTML = html; });

      if (fromUser) {
        showMedia(variant.media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', function () { update(true); });
      update(false);
    }

    var sticky = $('[data-sticky-atc]', section);
    var mainButton = $('[data-add-button]', form);
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(mainButton);
    }

    $$('[data-qty-step]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = $('input[name="quantity"]', btn.closest('.qty-input'));
        if (!input) return;
        var next = Math.max(1, Number(input.value || 1) + Number(btn.getAttribute('data-qty-step')));
        input.value = next;
      });
    });
  }

  /* ------------------------------------------------------------------
     Product recommendations
  ------------------------------------------------------------------ */
  function initRecommendations(el) {
    if (el.hasAttribute('data-loaded')) return;
    el.setAttribute('data-loaded', '');
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     Collection filters & sorting
  ------------------------------------------------------------------ */
  function initFilters(form) {
    if (form.hasAttribute('data-initialized')) return;
    form.setAttribute('data-initialized', '');
    function go() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      window.location.search = params.toString();
    }
    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="number"]')) return;
      go();
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); go(); });
  }

  /* ------------------------------------------------------------------
     Navigation: close open dropdowns on outside click
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    $$('.site-nav__details[open], .filter[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (!el.matches || !el.open) return;
    if (el.matches('.site-nav__details')) {
      $$('.site-nav__details[open]').forEach(function (d) { if (d !== el) d.removeAttribute('open'); });
    }
    if (el.matches('.filter')) {
      $$('.filter[open]').forEach(function (d) { if (d !== el) d.removeAttribute('open'); });
    }
    if (el.matches('.mobile-nav')) {
      document.documentElement.classList.add('no-scroll');
    }
  }, true);

  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (el.matches && el.matches('.mobile-nav') && !el.open) document.documentElement.classList.remove('no-scroll');
  }, true);

  /* ------------------------------------------------------------------
     Init + theme editor support
  ------------------------------------------------------------------ */
  function init(root) {
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    $$('[data-collection-filters]', root).forEach(initFilters);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('[data-cart-drawer]')) openCart();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target.querySelector('[data-cart-drawer]')) closeCart();
  });
})();
